import React from 'react'
import { Link } from 'react-router-dom'
const Bredcump = ({ Description,Heading,Title,Subtitle }) => {
  return (
    <div>
      <div className="bred_crumb">
  {/* animated dots */}
  <div className="dotes_anim_bloack">
    <div className="dots dotes_1" />
    <div className="dots dotes_2" />
    <div className="dots dotes_3" />
    <div className="dots dotes_4" />
    <div className="dots dotes_5" />
    <div className="dots dotes_6" />
    <div className="dots dotes_7" />
    <div className="dots dotes_8" />
    <div className="dots dotes_9" />
    <div className="dots dotes_10" />
  </div>
  <div className="container">
    <div className="bred_text">
      <span className="title_badge mb-1">{Heading}</span>
      <h1>{Title}</h1>
      <p>
        {Description}
      </p>
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <span>»</span>
        </li>
        <li>
          <span>{Subtitle}</span>
        </li>
      </ul>
    </div>
  </div>
</div>

    </div>
  )
}

export default Bredcump
